import {Button, Layout, Tabs} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import SUGMDT1D from './SUGMDT1D';
import SUGMDT2D from './SUGMDT2D';
import SUGMDT3D from './SUGMDT3D';
import SUGMDT4D from './SUGMDT4D';


const Content = Layout;

const SUGMDTabsD = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);
  const [Tno, setTno] = useState(appColors['ColorX']);
  const [Gno, setGno] = useState(appColors['ColorG2']);
  const [To, setTo] = useState(appColors['ColorX']);
  const [Go, setGo] = useState(appColors['ColorG2']);
  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTUno('white');
      setGUno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'tres') {
      setTno('white');
      setGno(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTo(appColors['ColorX']);
      setGo(appColors['ColorG2']);
    } else if (key === 'cuatro') {
      setTo('white');
      setGo(appColors['ColorX']);
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
      setTno(appColors['ColorX']);
      setGno(appColors['ColorG2']);
    }
  };
  const items_ = [
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '1.5vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Preparation of PSF<br/>files for each molecule</Button>, key: 'uno', children: <SUGMDT1D/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '1.5vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Preparation of the PSF<br/>and PDB files for<br/>the studied complex.</Button>, key: 'dos', children: <SUGMDT2D/>},
    {label: <Button style={{width: '20vh', height: '13vh', top: '2.3vh', fontSize: '1.8vh', borderWidth: '1.5vh', borderRadius: '1vh', color: Tno, fontWeight: 'bold', borderColor: Gno, background: Gno}}>Solvation, ionization<br/>and beta coloring</Button>, key: 'tres', children: <SUGMDT3D/>},
    {label: <Button style={{width: '15vh', height: '13vh', top: '2.3vh', fontSize: '1.8vh', borderWidth: '1.5vh', borderRadius: '1vh', color: To, fontWeight: 'bold', borderColor: Go, background: Go}}>Equilibration<br/>and run</Button>, key: 'cuatro', children: <SUGMDT4D/>},
  ];
  return (
    <Layout style={{margin: '-5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='1vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default SUGMDTabsD;
